import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'auth-apple-sign-in-button',
  templateUrl: './apple-sign-in-button.component.html',
  styleUrls: ['./apple-sign-in-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppleSignInButtonComponent {
  @Input() loading: boolean = false;
  @Input() label: string = 'Continue with Apple';

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  onClick(): void {
    if (this.loading) {
      return;
    }
    this.clicked.emit();
  }
}
